import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CStampFree } from '@models/imported/SagaSchema/CStampFree';
import { Observable } from 'rxjs';
import { Destination } from '../../schema/destination';

@Injectable({
  providedIn: 'root'
})
export class DestinationProxyService {
  constructor(private readonly http: HttpClient) {}

  getDestinations(): Observable<any> {
    return this.http.get('api/Service/GetDestinations');
  }

  setDestination(destination: Destination): Observable<CStampFree> {
    return this.http.post<CStampFree>('api/Service/AddDestination', destination);
  }
}
